import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  Divider,
  FlexDirection,
  FontWeight,
  Heading6,
  JustifyContent,
  Link,
  Space,
  Text,
} from '@gousto-internal/citrus-react'
import moment from 'moment'
import { useSelector } from 'react-redux'

import { client } from 'config/routes'
import { RecipeSummary } from 'routes/Checkout/Components/RecipeSummary'
import { getBasketDate, getBasketSlotId, getNumPortions } from 'selectors/basket'
import { getSlotTimes } from 'utils/deliveries'

export const BoxDetails = () => {
  const numPortions = useSelector(getNumPortions)
  const date = useSelector(getBasketDate)
  const deliveryDays = useSelector((state) => (state as any).boxSummaryDeliveryDays)
  const slotId = useSelector(getBasketSlotId)

  const deliveryDate = moment(date).format('dddd Do MMMM')
  const deliveryTime = getSlotTimes({ date, deliveryDays, slotId })

  return (
    <Box
      data-testing="checkoutBoxDetailsSection"
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      bg={Color.White}
      paddingBottom={[4, 6]}
      paddingH={[3, 6]}
    >
      <Box
        display={Display.Flex}
        justifyContent={JustifyContent.SpaceBetween}
        alignItems={AlignItems.FlexStart}
        paddingBottom={5}
      >
        <Heading6>{`Your box (${numPortions} people)`}</Heading6>
        <Link size={1} href={client.menu}>
          Edit order
        </Link>
      </Box>

      <RecipeSummary />

      <Divider />

      <Space size={4} />

      <Heading6>Delivery date</Heading6>

      <Space size={4} />

      <Text fontWeight={FontWeight.Bold} size={2}>
        {deliveryDate}
      </Text>
      <Text uppercase size={2}>
        {deliveryTime}
      </Text>
    </Box>
  )
}
